// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.companyInfoBg {
  width: 55%;
  min-height: 70%;
  background-color: var(--Foreground);
  border-radius: 0.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  position: absolute;
  z-index: 2;
  transition: all 0.7s ease-out;
}
.companyInfoBg h1 {
  font-size: 1.5rem;
  font-weight: 600;
  width: 100%;
  text-align: center;
  color: var(--TextColor);
}
.companyInfoBg button {
  margin-top: 0.6rem;
  width: 80%;
  border: none;
  outline: none;
  background-color: var(--AccentColor);
  color: white;
  border-radius: 0.3rem;
  padding: 1rem 0rem;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}
.companyInfoBg form {
  gap: 1.25rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
.companyInfoBg form .inputContainers {
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
}
.companyInfoBg form .inputContainers input {
  width: 100%;
  border: none;
  outline: none;
  border-bottom: 1px solid var(--Stroke);
  background-color: transparent;
  text-indent: 0.6rem;
  height: 2.5rem;
  color: var(--TextColor);
  font-size: 0.875rem;
}

.deletedComp {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/Components/CompanyRegistration/Info/Forms/CompanyInfo.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;AACJ;AACI;EACI,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AACR;AACI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACR;AACI;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AACR;AAAQ;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AAEZ;AADY;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sCAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AAGhB;;AAIA;EACI,aAAA;AADJ","sourcesContent":[".companyInfoBg{\n    width: 55%;\n    min-height: 70%;\n    background-color: var(--Foreground);\n    border-radius: .6rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    align-items: center;\n    justify-content: center;\n    padding: 1.25rem;\n    position: absolute;\n    z-index: 2;\n    transition: all 0.7s ease-out;\n\n    h1{\n        font-size: 1.5rem;\n        font-weight: 600;\n        width: 100%;\n        text-align: center;\n        color: var(--TextColor);\n    }\n    button{\n        margin-top: .6rem;\n        width: 80%;\n        border: none;\n        outline: none;\n        background-color: var(--AccentColor);\n        color: white;\n        border-radius: .3rem;\n        padding: 1rem 0rem;\n        font-size: 1rem;\n        font-weight: 600;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    form{\n        gap: 1.25rem;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-evenly;\n        align-items: center;\n        .inputContainers{\n            width: 80%;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 1.25rem;\n            input{\n                width: 100%;\n                border: none;\n                outline: none;\n                border-bottom: 1px solid var(--Stroke);\n                background-color: transparent;\n                text-indent: .6rem;\n                height: 2.5rem;\n                color: var(--TextColor);\n                font-size: 0.875rem;\n            }\n            \n        }\n    }\n}\n\n.deletedComp{\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
